<template>
    <div class="dimission-manage-wrap">
        <div class="page-filter_wrap">
            <div class="page-filter_wrap_left">
                <el-input
                    v-model="searchForm.keyword"
                    :autofocus="true"
                    class="filter-input"
                    clearable
                    placeholder="请输入姓名/手机号"
                    @clear="handleClickSearch"
                    @keyup.enter.native="handleClickSearch"
                >
                    <i slot="suffix" class="iconfont icon-sousuo" @click="handleClickSearch"></i>
                </el-input>
                <el-popover placement="right-start" width="550" trigger="click">
                    <div class="search_container">
                        <div class="search_top_container">
                            <span class="title">筛选</span>
                            <el-button
                                @click="handleClickReset"
                                size="mini"
                                :disabled="searchFilterList.findIndex((find) => find.field_value) > -1 ? false : true"
                                >清空筛选条件</el-button
                            >
                        </div>
                        <div class="search_bottom_container">
                            <ul>
                                <li v-for="item in searchFilterList">
                                    <div>
                                        <el-select size="small" v-model="item.field_key" disabled>
                                            <el-option label="部门" value="department_id"></el-option>
                                            <el-option label="离职状态" value="quit_status"></el-option>
                                            <el-option label="离职日期" value="date"></el-option>
                                            <el-option label="离职类型" value="quit_type"></el-option>
                                        </el-select>
                                    </div>
                                    <div class="search_filter_type">
                                        <el-select size="small" v-model="item.field_type" disabled>
                                            <el-option label="满足" value="eq"></el-option>
                                            <el-option label="不满足" value="neq"></el-option>
                                        </el-select>
                                    </div>
                                    <div>
                                        <template v-if="item.field_key == 'department_id'">
                                            <el-select
                                                :popper-append-to-body="true"
                                                @clear="handleClickClearDepartment()"
                                                clearable
                                                ref="department_select"
                                                size="small"
                                                placeholder="请选择部门"
                                                v-model.trim="item.field_value_name"
                                            >
                                                <el-option :value="[]" style="height: auto; padding: 0">
                                                    <el-tree
                                                        :data="departmentList"
                                                        :expand-on-click-node="false"
                                                        :props="{ children: 'children', label: 'relate_name' }"
                                                        ref="departmentTree"
                                                        @node-click="handleClickDepNode"
                                                        check-on-click-node
                                                        check-strictly
                                                        default-expand-all
                                                        highlight-current
                                                        node-key="relate_id"
                                                        :show-checkbox="false"
                                                        size="mini"
                                                        @check-change="handleClickSearch"
                                                    >
                                                    </el-tree>
                                                </el-option>
                                            </el-select>
                                        </template>
                                        <template v-if="item.field_key == 'quit_status'">
                                            <el-select
                                                clearable
                                                placeholder="请选择离职状态"
                                                size="small"
                                                v-model="item.field_value"
                                                filterable
                                                @change="handleClickSearch"
                                            >
                                                <el-option
                                                    :label="item.label"
                                                    :value="item.value"
                                                    :key="item.value"
                                                    v-for="item in dimissionStatusList"
                                                ></el-option>
                                            </el-select>
                                        </template>
                                        <template v-if="item.field_key == 'date'">
                                            <el-date-picker
                                                v-model="item.field_value"
                                                size="small"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                type="daterange"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期"
                                                range-separator="至"
                                                placeholder="请选择离职日期"
                                                @change="handleClickSearch"
                                            >
                                            </el-date-picker>
                                        </template>
                                        <template v-if="item.field_key == 'quit_type'">
                                            <el-select
                                                clearable
                                                placeholder="请选择离职类型"
                                                size="small"
                                                v-model="item.field_value"
                                                filterable
                                                @change="handleClickSearch"
                                            >
                                                <el-option
                                                    :label="item.type_value"
                                                    :value="item.type_id"
                                                    :key="item.type_id"
                                                    v-for="item in dimission_type_list"
                                                ></el-option>
                                            </el-select>
                                        </template>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <el-button size="small" slot="reference" class="custom_popover_button">
                        <i class="iconfont icon-shaixuan"></i>
                        <span
                            class="search_filter_length"
                            v-if="searchFilterList.filter((find) => find.field_value).length"
                        >
                            <span v-text="searchFilterList.filter((find) => find.field_value).length + '个条件'"></span>
                            <i class="el-icon-error" @click="handleClickReset"></i>
                        </span>
                    </el-button>
                </el-popover>
            </div>
            <div class="page-filter_wrap_right">
                <el-button 
                    @click="handleClickExport" 
                    v-auth="'person.quitListExport'"
                    permission_type="person"
                    route_name="DimissionManage">导出</el-button>
                <el-button type="primary"
                    v-auth="'person.applyQuit'"
                    permission_type="person"
                    route_name="DepartmentPersonnel"
                    @click="handleClickResig">办理离职</el-button>
            </div>
        </div>
        <div class="page-table">
            <p class="filter-count" v-if="filterCount">共{{ pagination.total }}条</p>
            <CustomVxeTable
                id="departmentTabel"
                ref="customTable"
                class="custom-table"
                :customConfig="tableCustomConfig"
                :isShowToolBar="true"
                :pagination="pagination"
                :reduceHeight="reduceHeight"
                :tableData="tableData"
                :loading="loading"
                @handleCurrentChange="handleCurrentChange"
                @handleSizeChange="handleSizeChange"
            >
                >
                <vxe-column fixed="left" field="name" title="姓名" min-width="126" show-overflow>
                    <template #default="{ row }">
                        <span class="link-label" @click.stop="handleClickConfirmMember(row)" v-if="row.name">{{ row.name }}</span>
                        <span v-else>--</span>
                    </template>
                </vxe-column>
                <vxe-column field="department_path" title="部门" min-width="125">
                    <template #default="{ row }">
                        <el-tooltip
                            v-if="row.department_name"
                            effect="dark"
                            :content="row.department_path || row.department_name"
                            placement="top-start"
                        >
                            <span>{{ row.department_name }}</span>
                        </el-tooltip>
                        <span v-else>--</span>
                    </template>
                </vxe-column>
                <vxe-column field="phone" title="手机号" min-width="137" show-overflow>
                    <template #default="{ row }">
                        <span>{{ row.phone || '--' }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="quit_status" title="离职状态" min-width="152" show-overflow>
                    <template #default="{ row }">
                        <span class="statusName">
                            <i
                                class="code"
                                :class="row.quit_status == 0 ? 'code0' : row.quit_status == 1 ? 'code1' : 'code2'"
                            ></i>
                            <span
                                v-text="
                                    row.quit_status == 0
                                        ? '待离职'
                                        : row.quit_status == 1
                                        ? '已离职'
                                        : row.quit_status == 2
                                        ? '已取消'
                                        : ''
                                "
                            >
                            </span>
                        </span>
                    </template>
                </vxe-column>
                <vxe-column field="quit_date" title="离职日期" min-width="152" show-overflow></vxe-column>
                <vxe-column field="quit_type" title="离职类型" min-width="152" show-overflow>
                    <template #default="{ row }">
                        <span
                            v-text="
                                dimission_type_list.find((find) => find.type_id == row.quit_type)
                                    ? dimission_type_list.find((find) => find.type_id == row.quit_type).type_value
                                    : ''
                            "
                        ></span>
                    </template>
                </vxe-column>
                <vxe-column field="quit_reason" title="离职原因" min-width="152" show-overflow></vxe-column>
                <vxe-column field="operation_time" title="操作时间" min-width="162" show-overflow></vxe-column>
                <vxe-column field="operate" width="90" fixed="right">
                    <template #header>
                        <span>操作</span>
                        <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                            <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                        </el-tooltip>
                    </template>
                    <template #default="{ row }">
                        <el-dropdown placement="bottom" trigger="click">
                            <el-button icon="el-icon-more" type="text"></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                    v-if="row.quit_status == 0 && hasConfirmQuitPermission"
                                    @click.native="handleClickLeaveConfirmQuit(row)"
                                >
                                    确认离职</el-dropdown-item
                                >
                                <el-dropdown-item
                                    v-if="row.quit_status == 0 && hasCancelQuitPermission"
                                    @click.native="handleClickLeaveCancelQuit(row)"
                                >
                                    取消离职</el-dropdown-item
                                >
                                <el-dropdown-item
                                    v-if="row.quit_status != 2 && hasOperatePermission"
                                    @click.native="handleClickLeaveOfficeEdit(row)"
                                    >修改离职信息</el-dropdown-item
                                >
                                <el-dropdown-item
                                    @click.native="handleClickResignationDetail(row)"
                                    v-if="row.quit_status == 2"
                                    >离职详情</el-dropdown-item
                                >
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </vxe-column>
                <template #empty>
                    <div class="custom-table-empty">
                        <div class="custom-table-empty-img">
                            <img src="https://download.hecoos.com/enlightv/2025-09/79aca5659d09f1a8f1161d7106c3ecf6.png" alt="">
                        </div>
                        <p class="custom-table-empty-txt">暂无数据</p>
                    </div>
                </template>
            </CustomVxeTable>
        </div>
        <handlingResignation
            :resignationDialogVisible.sync="resignationDialogVisible"
            v-if="resignationDialogVisible"
            ref="handlingResignation"
            @selectUser="selectHandlingUser"
        />
        <leaveOffice
            :leaveDialogVisible.sync="leaveDialogVisible"
            :user_info="user_info"
            v-if="leaveDialogVisible"
            @success="handleClickSearch"
        />
        <confirmMember ref="confirmMember" :type="confirmMemberType" />
        <resignationDetail
            :resignationDetailDialogVisible.sync="resignationDetailDialogVisible"
            @success="getTableData"
            :user_info="user_info"
            v-if="resignationDetailDialogVisible"
        />
    </div>
</template>
<script>
import * as XLSX from "xlsx";
import { getQuitReason, GetDepartmentList, quitList, cancelQuit, confirmQuit , quitListExport} from "@/api";
import { pagination } from "@/mixins";
import ListAdvancedFiltering from "@/components/pComponents/ListAdvancedFiltering";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import handlingResignation from "./component/handling_resignation.vue";
import leaveOffice from "../component/leave_office.vue";

import confirmMember from "../component/member_confirm.vue";
import resignationDetail from "./component/resignation_detail.vue";
import {mapGetters, mapState} from "vuex";

export default {
    name: "DimissionManage",
    components: {
        ListAdvancedFiltering,
        CustomVxeTable,
        handlingResignation,
        leaveOffice,

        confirmMember,
        resignationDetail,
    },
    data() {
        return {
            searchForm: {
                keyword: "",
            },
            searchFilterList: [
                {
                    field_key: "department_id",
                    field_name: "部门",
                    field_value: "",
                    field_value_name: "",
                    field_type: "eq",
                },
                {
                    field_key: "quit_status",
                    field_name: "离职状态",
                    field_value: "",
                    field_type: "eq",
                },
                {
                    field_key: "date",
                    field_name: "离职日期",
                    field_value: "",
                    field_type: "eq",
                },
                {
                    field_key: "quit_type",
                    field_name: "离职类型",
                    field_value: "",
                    field_type: "eq",
                },
            ],
            dimissionStatusList: [
                { label: "待离职", value: "0" },
                { label: "已离职", value: "1" },
                { label: "已取消", value: "2" },
            ],
            dimission_type_list: [],
            departmentList: [],
            depPopoverShow: false,
            tableData: [],
            tableCustomConfig: {
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "name";
                },
                allowSort: true,
            },
            confirmMemberType: "pendingOffice", // 人员类型
            resignationDetailDialogVisible: false,

            leaveDialogVisible: false,
            user_info: null,

            resignationDialogVisible: false,
        };
    },
    mixins: [pagination],
    computed: {
        filterCount() {
            return this.searchFilterList.filter((item) => item.field_value).length;
        },
        reduceHeight() {
            return this.filterCount ? 200 : this.tableData.length ? 170 : 120;
        },
        ...mapGetters(['hasPermission']),
        // 修改离职信息
        hasOperatePermission() {
            return this.hasPermission('person.editQuitInfo', 'person', 'DimissionManage');
        },
        // 确认离职
        hasConfirmQuitPermission() {
            return this.hasPermission('person.confirmQuit', 'person', 'DepartmentPersonnel');
        },
        // 取消离职
        hasCancelQuitPermission() {
            return this.hasPermission('person.cancelQuit', 'person', 'DepartmentPersonnel');
        },
    },
    created() {
        this.getQuitReason();
        this.getDepartmentList();
        this.getTableData();
    },
    mounted() {},
    methods: {
        getQuitReason() {
            getQuitReason({}).then((res) => {
                if (res.code === 200) {
                    this.dimission_type_list = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 获取部门
        getDepartmentList() {
            GetDepartmentList({ name: this.keyWord }).then((res) => {
                if (res.code === 200) {
                    this.departmentList = res.data || [];
                }
            });
        },
        handleClickClearDepartment() {
            this.searchFilterList.forEach((item) => {
                if (item.field_key == "department_id") {
                    item.field_value = "";
                    item.field_value_name = "";
                }
            });
            this.handleClickSearch();
        },
        handleClickDepNode(data, node, nodeData) {
            this.searchFilterList.forEach((item) => {
                if (item.field_key == "department_id") {
                    item.field_value = data.relate_id;
                    item.field_value_name = data.relate_name;
                }
            });
            this.$refs.department_select[0].handleClose();
        },

        // 清空筛选条件
        handleClickReset() {
            this.searchFilterList.forEach((item) => {
                this.$set(item, "field_value", "");
                this.$set(item, "field_value_name", "");
            });
            this.handleClickSearch();
        },
        // 搜索
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = val.pageSize;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value !== "") {
                    postData[item.field_key] = item.field_value;
                }
            });
            quitList(postData).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.tableData = data;
                    this.pagination.total = total;
                }
                this.loading = false;
            });
        },
        handleClickResig() {
            this.resignationDialogVisible = true;
        },
        selectHandlingUser(data) {
            this.user_info = data;
            this.leaveDialogVisible = true;
        },
        // 确认离职
        handleClickLeaveConfirmQuit(row) {
            const h = this.$createElement;
            this.$msgbox({
                title: "确认离职",
                message: h("div", null, [
                    h("span", null, "确认离职后，该员工的帐号将关闭，请确保工作交接已完成！！！"),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: "prompt_message_custom",
                confirmButtonText: "确定",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: "",
                showClose: false,
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    let postData = {
                        id: row.id,
                    };
                    this.loading = true;
                    confirmQuit(postData).then((res) => {
                        if (res.code === 200) {
                            this.$message.success("操作成功");
                            this.getTableData();
                        }
                        this.loading = false;
                    });
                })
                .catch(() => {});
        },
        // 取消离职
        handleClickLeaveCancelQuit(row) {
            const h = this.$createElement;
            this.$msgbox({
                title: "取消离职",
                message: h("div", null, [h("span", null, "取消离职后，该员工将恢复为正常在职状态。")]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                customClass: "prompt_message_custom",
                confirmButtonText: "确定",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                confirmButtonClass: "",
                showClose: false,
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    let postData = {
                        id: row.id,
                    };
                    this.loading = true;
                    cancelQuit(postData).then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message);
                            this.getTableData();
                        }
                        this.loading = false;
                    });
                })
                .catch(() => {});
        },
        // 离职信息修改
        handleClickLeaveOfficeEdit(row) {
            this.user_info = {
                id: row.id,
                user_id: row.uid,
                user_name: row.name,
                department_path: row.department_path ? row.department_path : "",
                avatar: row.avatar,
            };
            this.leaveDialogVisible = true;
        },
        // 离职详情
        handleClickResignationDetail(row) {
            this.user_info = {
                id: row.id,
                user_id: row.uid,
                user_name: row.name,
                department_path: row.department_path ? row.department_path : "",
                avatar: row.avatar,
                quit_status: row.quit_status,
            };
            this.resignationDetailDialogVisible = true;
        },
        // 点击姓名操作
        handleClickConfirmMember(row) {
            // this.confirmMemberType = row.status;
            // this.$refs.confirmMember &&
            // this.$refs.confirmMember.handleDialogShow();
            this.user_info = {
                id: row.id,
                user_id: row.uid,
                user_name: row.name,
                department_path: row.department_path ? row.department_path : "",
                avatar: row.avatar,
                quit_status: row.quit_status,
            };
            this.resignationDetailDialogVisible = true;
        },
        handleClickCustom() {
            this.$refs.customTable.handleOpenCustomShow();
        },
        // 导出
        handleClickExport() {
            let tableData = [];
            let HeaderInfo = [];
            let headerFileds = [
                {
                    field_key: "name",
                    field_name: "姓名",
                },
                {
                    field_key: "department_path",
                    field_name: "部门",
                },
                {
                    field_key: "phone",
                    field_name: "手机号",
                },
                {
                    field_key: "quit_status",
                    field_name: "离职状态",
                },
                {
                    field_key: "quit_date",
                    field_name: "离职日期",
                },
                {
                    field_key: "quit_type",
                    field_name: "离职类型",
                },
                {
                    field_key: "quit_reason",
                    field_name: "离职原因",
                },
                {
                    field_key: "operation_time",
                    field_name: "操作时间",
                },
            ];
            let postData = {
                page: 1,
                pageSize: this.pagination.total,
                keyword: this.searchForm.keyword,
            };
            this.searchFilterList.forEach((item) => {
                if (item.field_value !== "") {
                    postData[item.field_key] = item.field_value;
                }
            });
            this.loading = true;
            quitListExport(postData)
                .then((res) => {
                    if (res.code === 200) {
                        var { data } = res.data;
                        HeaderInfo = headerFileds.map((item) => item.field_name);
                        tableData = data.map((row) => {
                            let itemdata = [];
                            headerFileds.forEach((field) => {
                                if (field.field_key == "quit_status") {
                                    itemdata.push(
                                        row.quit_status == 0
                                            ? "待离职"
                                            : row.quit_status == 1
                                            ? "已离职"
                                            : row.quit_status == 2
                                            ? "已取消"
                                            : ""
                                    );
                                } else if (field.field_key == "quit_type") {
                                    itemdata.push(
                                        this.dimission_type_list.find((find) => find.type_id == row.quit_type)
                                            ? this.dimission_type_list.find((find) => find.type_id == row.quit_type)
                                                  .type_value
                                            : ""
                                    );
                                } else if (field.field_key == "department_path") {
                                    itemdata.push(row.department_path || row.department_name);
                                } else {
                                    itemdata.push(row[field.field_key]);
                                }
                            });
                            return itemdata;
                        });
                        const xlsxData = [HeaderInfo, ...tableData];
                        const ws = XLSX.utils.aoa_to_sheet(xlsxData);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
                        const fileName = this.nowDate();
                        setTimeout(() => {
                            XLSX.writeFile(wb, fileName);
                            this.$message.success("导出成功");
                            this.loading = false;
                        }, 2000);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        nowDate(type) {
            const today = new Date();
            const year = today.getFullYear();
            let month = today.getMonth() + 1;
            month = month < 10 ? "0" + month : month;
            const date = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
            if (type && type == "date") {
                return `${year}-${month}-${date}`;
            } else if (type && type == "date2") {
                return `${year}-${month}`;
            } else {
                return `离职管理${year}年${month}月${date}日${hours}时${minutes}分${seconds}秒.xlsx`;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/filter-form-wrap.scss";

.dimission-manage-wrap {
    padding: 16px;

    .filter-btn-wrap_content {
        .list-item {
            & > div {
                margin-right: 8px;
            }
        }
    }
    .custom-table {
        ::v-deep {
            .vxe-table {
                margin-top: 8px;
            }
        }
    }
    .filter-count {
        margin-top: 16px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }
}
.search_container {
    width: 100%;
    padding: 4px;
    box-sizing: border-box;

    .search_top_container {
        display: flex;
        justify-content: space-between;

        span.title {
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            font-weight: bold;
        }

        .el-button {
            padding: 5px 10px;
        }
    }

    .search_bottom_container {
        padding: 16px 0 0px;
        box-sizing: border-box;

        ul {
            width: 100%;

            li {
                width: 100%;
                display: flex;
                margin-bottom: 12px;
                & > div:nth-child(1) {
                    width: 184px;
                }
                & > div:nth-child(2) {
                    width: 84px;
                }
                & > div:nth-child(3) {
                    width: 230px;
                    .el-select {
                        width: 100%;
                    }
                }

                .search_filter_type {
                    margin: 0 8px;
                    width: 86px;
                    max-width: 86px;
                }

                .el-date-editor.el-input {
                    width: 100%;
                    display: block;
                }
                .el-date-editor {
                    width: 100% !important;
                    ::v-deep {
                        .el-range-separator {
                            width: 10%;
                            padding: 0;
                        }
                    }
                }
            }
        }
    }
}

.custom_popover_button {
    padding: 8px 8px;
    margin-left: 0px;
    i {
        font-size: 14px;
    }
    .search_filter_length {
        margin-left: 8px;
        i {
            margin-left: 8px;
            color: rgba(173, 173, 173, 1);
        }
    }
}
.code {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 4px;
    background: rgba(191, 191, 191, 1);
    display: inline-block;
    vertical-align: middle;
    margin-top: -3px;
}
.code0 {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 4px;
    background: rgba(240, 170, 50, 1);
}
.code1 {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 4px;
    background: rgba(90, 179, 51, 1);
}
</style>
<style lang="scss">
.dimission-custom-form {
    .el-form-item__content {
        .list-item {
            .list-item-mr8 {
                margin-right: 8px;
            }
        }
    }
}
</style>
